module.exports = __webpack_public_path__ + "static/media/glenveagh.8102c968.png";